import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, BookOpen } from "lucide-react";
import { apiClient } from "@/lib/api";
import { SectionHeading } from "./Services";

export const BlogPreview = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    apiClient.get("/blog").then((r) => setPosts((r.data || []).slice(0, 3))).catch(() => {});
  }, []);

  if (posts.length === 0) return null;

  return (
    <section id="guides" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32" data-testid="blog-preview-section">
      <SectionHeading id="guides" overline="Study Guides" title="Free guides that" accent="raise grades." />
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8">
        {posts.map((p, i) => (
          <motion.div
            key={p.id}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.1, ease: [0.33, 1, 0.68, 1] }}
          >
            <Link
              to={`/blog/${p.slug}`}
              data-testid={`blog-preview-card-${i}`}
              className="luxury-card group flex h-full flex-col rounded-xl p-7"
            >
              <BookOpen size={20} className="mb-5 text-[#A07E1F]" />
              <h3 className="font-serif-display text-xl font-semibold leading-snug text-[#12294D] transition-colors duration-300 group-hover:text-[#A07E1F] sm:text-2xl">
                {p.title}
              </h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-[#46586F]">{p.excerpt}</p>
              <span className="mt-6 flex items-center gap-2 font-mono-accent text-[11px] uppercase tracking-[0.2em] text-[#A07E1F]">
                Read Guide <ArrowRight size={13} className="transition-transform duration-300 group-hover:translate-x-1" />
              </span>
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
